import React from 'react';
import SearchBox from '@/components/seo/search-area/SearchBox';
import CitySearch from '@/components/seo/search-area/CitySearch';
import { NATION_WIDE } from '@/constants/city';
import {
  CascadeOption,
  Option,
} from '@/components/form/cascade-select/CascadeSelect';
import { SEARCH_TYPE, SEARCH_MODE_TYPE } from '@/constants/common';
import { SearchType } from '@/types/job-title';
import { getJobCompanyCity, getJobTitleCity } from '@/api/tanzhi';

const SearchArea = (props: {
  searchValue: SearchType;
  handeSearchValue: (value: SearchType) => void;
  cityValue: Option;
  handleCitySearch: (value: Option) => void;
  initSearchValue?: SearchType;
}) => {
  const {
    initSearchValue = null,
    searchValue,
    cityValue,
    handeSearchValue,
    handleCitySearch,
  } = props;

  const [cityOptions, setCityOptions] = React.useState<CascadeOption[]>([
    NATION_WIDE,
  ]);

  const fetchCityData = (
    fetchFunction: (id: string) => Promise<any>,
    id: string,
  ) => {
    return fetchFunction(id);
  };

  const handleSearch = (value: SearchType, isInit?: boolean) => {
    if (!value || (value.id === searchValue?.id && !isInit)) return;
    handeSearchValue(value);
    handleCitySearch(NATION_WIDE);
    const searchType = value.search_type;
    fetchCityData(
      searchType === SEARCH_TYPE.COMPANY ? getJobCompanyCity : getJobTitleCity,
      value.id,
    ).then((res) => {
      setCityOptions([NATION_WIDE, ...res.data]);
    });
  };

  React.useEffect(() => {
    initSearchValue && handleSearch(initSearchValue, true);
  }, [initSearchValue]);

  return (
    <>
      <SearchBox
        initValue={initSearchValue}
        onChange={handleSearch}
        enableAnimation={false}
        placeholder="搜索职场薪资·公司"
        className="w-full rounded-lg bg-slate-50"
        inputBorderColor="border-none"
        inputClassName="h-14 pl-6 pr-4"
        showEndAdornment={false}
        mode={SEARCH_MODE_TYPE.JOB_SEARCH}
      />
      <CitySearch
        cityValue={cityValue}
        existCities={cityOptions}
        onSearch={handleCitySearch}
        borderColor="border-none"
        inputClassName="h-14 px-4"
      />
    </>
  );
};

export default SearchArea;
